import * as React from 'react';
import { Tournament } from 'Src/models/tournament';
import { TOURNAMENT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/tournament';

const getSportColor = (key: string): string => {
  const hash = String(key || 'sport')
    .split('')
    .reduce((value, char) => ((value << 5) - value + char.charCodeAt(0)) | 0, 0);
  return `hsl(${Math.abs(hash) % 360}, 58%, 47%)`;
};

export const ParticipantTournamentNameCell = (tournament: Tournament): React.ReactElement => {
  const sportName = tournament.sport?.name || 'Sport not set';
  const type = TOURNAMENT_TYPE_SERVER_TO_CLIENT_MAPPING[tournament.type] || tournament.type || 'Type not set';
  const colour = getSportColor(tournament.sport?.id || tournament.sportId || sportName);

  return (
    <td>
      <div className="participantTournamentName">
        <strong>{tournament.name || '—'}</strong>
        <div className="participantTournamentName__meta">
          <i style={{ backgroundColor: colour }} />
          <span>{sportName}</span>
          <b>·</b>
          <span>{type}</span>
        </div>
      </div>
    </td>
  );
};
